import MfcClientInfo from '../libraries/mfc/MfcClientInfo'
import { controller } from '../utilities/abortController'

const getHardwareConcurrency = () => {
    try {
        return (window.navigator.hardwareConcurrency || '') + ''
    } catch (_) {
        return ''
    }
}

const trackAffiliatesClosure =
    (sent?: boolean) =>
    (sessionID = 0, username = '') => {
        try {
            if (sent || process.env.NODE_ENV === 'development') {
                return
            }

            sent = true

            const mfcClientInfo = new MfcClientInfo()
            const time = new Date()
            const params = Object.fromEntries(
                new URLSearchParams(window?.location?.search || ''),
            )

            const clientInfo = {
                ...params,
                // do not override these below
                uid: String(mfcClientInfo.GetClientUID()),
                tz: String(-time.getTimezoneOffset() / 60),
                dpi_test: String(mfcClientInfo.GetDPI('entropic')),
                username,
                co: String(time.getTime()),
                sz: screen.width + 'x' + screen.height,
                session_id: String(sessionID),
                conn_mode: 'websocket',
                loc_host: window.location.host,
                crc_system_info: String(mfcClientInfo.getCrcSystemInfo()),
                crc_system_fonts: String(
                    mfcClientInfo.getCrcSystemInfo('fonts'),
                ),
                hardware_concurrency: getHardwareConcurrency(),
            }

            fetch('https://www.myfreecams.com/php/client_info.php', {
                headers: {
                    'Content-Type':
                        'application/x-www-form-urlencoded;charset=UTF-8',
                },
                body: new URLSearchParams(clientInfo),
                credentials: 'include',
                method: 'POST',
                signal: controller.signal,
            }).catch((error) => {
                console.error('[trackAffiliates]', error)
            })
        } catch (error) {
            console.error('[trackAffiliates]', error)
        }
    }

export const trackAffiliates = trackAffiliatesClosure()
